import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';
import { _t } from 'utils/translation';
import CommonSelector from './common-selector';

export default ({
  onChange, error, location, validLocations, value, isOpen = false, external,
}) => {
  let { [ACTIONS_TYPES.DATA_CENTER.GET_ALL]: dataCenters = [] } = useSelector((e) => e);
  useEffect(() => {
    if (!external) {
      actions.dataCenter.getAll({});
    }
    // eslint-disable-next-line
  }, []);

  if (location) dataCenters = dataCenters.filter((e) => e?.properties?.location === location);
  if (validLocations) dataCenters = dataCenters.filter((e) => validLocations.includes(e?.properties?.location));

  return (
    <CommonSelector
      title={_t('SELECT_DATACENTER')}
      itemIcon="boxes"
      setItemTitle={(e) => e?.properties?.name}
      items={dataCenters}
      onChange={onChange}
      returnValuePropOnly={false}
      value={value}
      error={error}
      isFilter
      isCollapsed={!isOpen}
    />
  );
};
